import { keyBy } from 'lodash-es'

export type Menu = {
  name: string
  path: string
  isActive: (pathname: string) => boolean
  isNew: boolean
}

export const MENU_LIST: Menu[] = [
  {
    name: 'Restake',
    path: '/restake',
    isActive: (pathname: string) => pathname.startsWith('/restake'),
    isNew: false,
  },
  {
    name: 'Stake',
    path: '/stake',
    isActive: (pathname: string) => pathname === '/stake' || pathname === '/unstake',
    isNew: false,
  },
  {
    name: 'Bridge',
    path: '/bridge',
    isActive: (pathname: string) => pathname === '/bridge',
    isNew: true,
  },
  {
    name: 'Earn',
    path: '/earn',
    isActive: (pathname: string) => pathname === '/earn',
    isNew: false,
  },
  {
    name: 'Airdrops',
    path: '/airdrops',
    isActive: (pathname: string) => pathname === '/airdrops',
    isNew: false,
  },
  {
    name: 'LAIR',
    path: '/lair',
    isActive: (pathname: string) => pathname === '/lair' || pathname === '/checker',
    isNew: false,
  },
  {
    name: 'Farm',
    path: '/farm',
    isActive: (pathname: string) => pathname === '/farm',
    isNew: false,
  },
  {
    name: 'Reward',
    path: '/reward',
    isActive: (pathname: string) => pathname === '/reward',
    isNew: false,
  },
]

export const MENU_LIST_MAP = keyBy(MENU_LIST, item => item.name)

export const APP_MENU_LIST = [MENU_LIST_MAP['Bridge'], MENU_LIST_MAP['Farm'], MENU_LIST_MAP['Reward']]

export const DESKTOP_MENU_LIST = [
  MENU_LIST_MAP['Restake'],
  MENU_LIST_MAP['Stake'],
  MENU_LIST_MAP['Earn'],
  MENU_LIST_MAP['Airdrops'],
  MENU_LIST_MAP['LAIR'],
]
